import Row from "page/Automatensuche/interface/RowTypes";

// this one would create a global accessible Closure and holds Data for one Session
export const DepositMachineContainer: Array<Row> = [];
